export enum CouponStatus { 
    CURRENT = 1,
    HISTORICAL = 2
}